import script from "./CreateEmailAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./CreateEmailAccount.vue?vue&type=script&setup=true&lang=js"

import "./CreateEmailAccount.vue?vue&type=style&index=0&id=3151ff9c&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3151ff9c"]])

export default __exports__